import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import '@/assets/styles/index.scss'
import "@/assets/styles/fuyun.scss"
import './assets/styles/fontSize.scss'
import  "./utils/rem"
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
